import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Features from './components/Features/Features';
import Personas from './components/Personas/Personas';
import Security from './components/Security/Security';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import ContactPage from './pages/ContactPage';
import PricingPage from './pages/PricingPage';
import SitemapPage from './pages/SitemapPage';
import FeaturesSidebar from './components/FeaturesSidebar/FeaturesSidebar';
import './App.css';

function Home() {
  return (
    <>
      <Hero />
      <About />
      <Features />
      <Personas />
      <Security />
      <Contact />
      <Footer />
    </>
  );
}

function FeaturesPage() {
  return (
    <div className="flex justify-center items-center min-h-[90vh] bg-[#f7fafd]">
      <FeaturesSidebar />
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <div className="pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/sitemap" element={<SitemapPage />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
